import { z } from "zod";

/*
 * KOReader sync (kosync) contract: field limits and the request body. The server maps validation
 * failures to the reference server's error codes instead of the app's `validation_failed` shape.
 */

export const KOSYNC_DOCUMENT_MAX = 64;
export const KOSYNC_DOCUMENT_PATTERN = /^[A-Za-z0-9_]+$/;

/** Everything except `document`, which has dedicated error codes (2004 missing, 2007 bad characters). */
export const kosyncProgressBodySchema = z.object({
  progress: z.string().max(2048),
  percentage: z.number().min(0).max(1),
  device: z.string().min(1).max(100),
  device_id: z.string().max(100).nullish(),
});
export type KosyncProgressBody = z.infer<typeof kosyncProgressBodySchema>;

export type KosyncDocumentCheck = "ok" | "missing" | "invalid" | "wrong_type";

/** 2004 for a missing/empty document, 2007 for unsupported characters or length, 2003 for a non-string. */
export function checkKosyncDocument(value: unknown): KosyncDocumentCheck {
  if (value === undefined || value === null || value === "") return "missing";
  if (typeof value !== "string") return "wrong_type";
  if (value.length > KOSYNC_DOCUMENT_MAX || !KOSYNC_DOCUMENT_PATTERN.test(value)) return "invalid";
  return "ok";
}
